import { Component } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { routerAnimationOne } from './core/_animations/router-animations.contants';
import { InactivityService } from './core/_services/inactivity.services';

@Component({
  selector: 'forrest-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  animations: [routerAnimationOne]
})
export class AppComponent {
  title = 'Wibo';
  constructor(
    private router: Router,
    private _inactivityService: InactivityService
  ) { }

  ngOnInit() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        const urlTree = this.router.parseUrl(event.url);
        if (urlTree.queryParamMap.keys.length === 0) {
          window.scrollTo(0, 0);
        }
      }
    });
  }


  getAnimationState(outlet: RouterOutlet) {
    console.log(outlet)
    return outlet?.isActivated ? outlet?.activatedRoute : { toString: () => '' };
  }
}
